import { createContext } from 'react'

import type { UserRole } from '@/types/api'

export type DevRolePreviewContextValue = {
  previewRole: UserRole | null
  setPreviewRole: (role: UserRole | null) => void
  clearPreview: () => void
  isPreviewActive: boolean
}

export const DevRolePreviewContext =
  createContext<DevRolePreviewContextValue | null>(null)
